export { default } from './StockCardSlider';
